export const getNowDate = () => {
  return new Date();
};
